import { Providers } from './providers'

import { AppShell } from '@/components/layout'

export function App() {
  return (
    <Providers>
      <AppShell />
    </Providers>
  )
}
